export function includes(arr, value) {
    if (!Array.isArray(arr) || arr.length === 0) return false
    else return arr.includes(value)
}

